export default "__VITE_ASSET__BFF8seLM__";